import StoreIntegrationStore from './StoreIntegrationStore'

export default StoreIntegrationStore
